<div class="error-page">
    <h1>Oops! Something went wrong</h1>
    <p>We encountered an error while processing your request. Please try again later.</p>
    <button (click)="goBack()">Go Back</button>
  </div>
  